'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _BaseField = require('uniforms/BaseField');

var _BaseField2 = _interopRequireDefault(_BaseField);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _filterDOMProps = require('uniforms/filterDOMProps');

var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);

var _gridClassName = require('./gridClassName');

var _gridClassName2 = _interopRequireDefault(_gridClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubmitField = function SubmitField(_ref, _ref2) {
    var _ref2$uniforms = _ref2.uniforms,
        error = _ref2$uniforms.error,
        state = _ref2$uniforms.state;
    var className = _ref.className,
        disabled = _ref.disabled,
        inputClassName = _ref.inputClassName,
        inputRef = _ref.inputRef,
        value = _ref.value,
        wrapClassName = _ref.wrapClassName,
        props = (0, _objectWithoutProperties3.default)(_ref, ['className', 'disabled', 'inputClassName', 'inputRef', 'value', 'wrapClassName']);

    var hasWrap = !!(state.grid || wrapClassName);

    var blockInput = _react2.default.createElement('input', {
        className: inputClassName,
        disabled: disabled === undefined ? !!(error || state.disabled) : disabled,
        ref: inputRef,
        type: 'submit',
        value: value
    });

    return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ className: (0, _classnames2.default)(className, { 'has-danger': error, row: state.grid }) }, (0, _filterDOMProps2.default)(props)),
        hasWrap && _react2.default.createElement(
            'label',
            { className: (0, _classnames2.default)('form-control-label', (0, _gridClassName2.default)(state.grid, 'label')) },
            '\xA0'
        ),
        hasWrap && _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(wrapClassName, (0, _gridClassName2.default)(state.grid, 'input')) },
            blockInput
        ),
        !hasWrap && blockInput
    );
};

SubmitField.contextTypes = _BaseField2.default.contextTypes;
SubmitField.defaultProps = { inputClassName: 'btn btn-primary' };

exports.default = SubmitField;


/*****************
 ** WEBPACK FOOTER
 ** ./~/uniforms-bootstrap3/SubmitField.js
 ** module id = ./node_modules/uniforms-bootstrap3/SubmitField.js
 ** module chunks = 0
 **/